import { Link } from "react-router";
import ImageComponent from "../../components/core/Image/Image";
import Text from "../../components/core/Text/Text";
import { FilterCategory } from "./Browse";
import styles from "./Image.module.scss";

interface Data {
  id: string;
  image: string;
  title: string;
  subTitle: string;
}

interface ImageProps {
  data: Data[];
  category: FilterCategory;
}

const Image = ({ data, category }: ImageProps) => {
  return (
    <div className={styles.items}>
      {data.map((item) => (
        <Link
          to={`/browse/${category}/${item.id}`}
          className={styles.item}
          key={item.id}
        >
          <ImageComponent src={item.image} className={styles.image} />
          <Text size={3} text={item.title} className={styles.title} />
          <Text size={5} text={item.subTitle} className={styles.subTitle} />
        </Link>
      ))}
    </div>
  );
};

export default Image;
